import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError, timeout } from 'rxjs/operators';
import { ApplicationConfig } from '../config/config';
import { EncryptedToken } from '../deeplink/models/token.interface';
import {
  DECRYPTION_API_URL,
  DEFAULT_TIMEOUT,
  ENCRYPTION_API_URL
} from './deeplink.constants';
@Injectable({
  providedIn: 'root'
})
export class ApiWrapperService {
  constructor(private http: HttpClient, private config: ApplicationConfig) {}

  async decryptToken(token: EncryptedToken, appTimeout?: number) {
    appTimeout = appTimeout || DEFAULT_TIMEOUT;
    const customerHeader = new HttpHeaders({
      'Content-type': 'application/json; charset=utf-8'
    });
    customerHeader.append('Accept', 'application/json');
    if (token) {
      const data = await this.http
        .post(DECRYPTION_API_URL, token, {
          headers: customerHeader
        })
        .pipe(timeout(appTimeout), catchError(this.timeOutErrorHandler))
        .pipe(
          catchError((err) => {
            console.log('Handling error...', err);
            return throwError(err);
          })
        )
        .toPromise()
        .catch((err) => {
          this.errorHandler(err);
        });
      return data;
    } else {
      const error = 'token is not valid';
      return error;
    }
  }

  async encryptDataset(dataset: Object, appTimeout?: number) {
    appTimeout = appTimeout || DEFAULT_TIMEOUT;
    const customerHeader = new HttpHeaders({
      'Content-type': 'application/json; charset=utf-8'
    });
    customerHeader.append('Accept', 'application/json');
    if (dataset) {
      const res = await this.http
        .post(ENCRYPTION_API_URL, dataset, {
          headers: customerHeader
        })
        .pipe(timeout(appTimeout), catchError(this.timeOutErrorHandler))
        .pipe(
          catchError((err) => {
            console.log('Handling error...', err);
            return throwError(err);
          })
        )
        .toPromise()
        .catch((err) => {
          this.errorHandler(err);
        });
      return dataset;
    } else {
      const error = 'dataset is not valid';
      return error;
    }
  }

  private errorHandler(error) {
    console.log(error.message);
    return throwError(error);
  }

  private timeOutErrorHandler(error) {
    console.log(JSON.stringify(error));
    if (error.name == 'TimeoutError') {
      console.log('Timeout error.');
    } else {
      console.log(JSON.stringify(error));
    }
    return throwError(error);
  }
}
